module.exports = __webpack_public_path__ + "img/payon-sm.f449bf99.svg";